import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
/* eslint-disable */
/*设置提醒组件
 *componentCenter.setReminder.setBuyRemind(options) 设置抢购提醒
 * 详情页、列表页调用传参
 * options={
 * 	pageType:1, //1.详情页、列表页调用  2.推广产品页调用
 *  activityId:"123",//必传
 *  goodId:"1852",//必传
 *  type:1, //非必传 默认1，1.预约 2.取消预约
 *  positionStr:"center", //非必传，默认"center"，设置或取消提醒成功弹框的位置 "center" "top" "bottom"
 *  callback:function(){} //回调函数
 * }
 *
 * 推广产品页调用传参
 * options={
 * 	pageType:2,//1.详情页、列表页调用  2.推广产品页调用
 *  activityId:"123",//必传
 *  goodId:"1852",//必传
 *  promoterId:"123",//必传
 *  type:1, //非必传 默认1，1.预约 2.取消预约
 *  positionStr:"center", //非必传，默认"center"，设置或取消提醒成功弹框的位置 "center" "top" "bottom"
 *  callback:function(){} //回调函数
 * }
 */
import { toast, showLoading, hideLoading } from '@ykz/ykz-util/base';
import databus, { Origins } from '@ykz/ykz-http/core';
export default {
  name: 'setReminder',
  data: function data() {
    return {
      showSetReminder: false,
      //显示设置提醒弹框
      pageIndex: 0,
      //1.未关注公众号弹框   2.设置或取消提醒成功toast
      wxQrCode: '',
      //公众号二维码
      type: 1,
      //设置或取消，默认1，1预约 2取消预约
      positionStr: 'center',
      //设置或取消提醒成功弹框的位置 "center" "top" "bottom"
      isAPP: window.mobileEnv == 'app' ? true : false,
      //是否在云客赞app打开页面
      isOther: getUrlParams('isOther') || '' //非云客公众号直接通过链接访问所带的参数，用来隐藏二维码
    };
  },

  mounted: function mounted() {
    _typeof(window.componentCenter) == 'object' || (window.componentCenter = {});
    window.componentCenter.setReminder = this;
    console.log('ycf组件初始化：setReminder');
    //this.setBuyRemind(); //测试
  },

  methods: {
    //设置抢购提醒
    setBuyRemind: function setBuyRemind(options) {
      if (this.time) {
        clearTimeout(this.time);
        this.showSetReminder = false;
      }
      options = options || {};
      options.callback = options.callback || function () {};
      this.type = options.type || 1;
      this.positionStr = options.positionStr || 'center';
      var temp = {},
        that = this;
      if (options.pageType == 1) {
        temp.url = '/apiv2/room/remind';
        temp.data = {
          activityId: options.activityId || '',
          goodId: options.goodId || '',
          userId: window.userId,
          type: this.type
        };
      } else {
        temp.url = '/apiv2/marketing/remind';
        temp.data = {
          activityId: options.activityId || '',
          goodId: options.goodId || '',
          promoterId: options.promoterId || '',
          type: this.type
        };
      }
      databus({
        url: temp.url,
        type: 'post',
        data: temp.data,
        success: function success(res) {
          if (res.code == 1000 && res.bcode == 100) {
            that.showSetReminder = true;
            if (res.content && res.content.isBind || that.type == 2 || that.isAPP || that.isOther) {
              that.pageIndex = 2;
              that.time = setTimeout(function () {
                that.showSetReminder = false;
              }, 3000);
            } else {
              that.wxQrCode = res.content.wxQrCode || '';
              that.pageIndex = 1;
            }
            options.callback();
          } else {
            toast(res.message || '设置提醒失败，请重试！');
          }
        },
        error: function error() {
          toast('网络有误，请重试');
        },
        beforeSend: function beforeSend() {
          showLoading({
            cover: true,
            opacity: 0
          });
        },
        complete: function complete() {
          hideLoading();
        }
      });
    }
  }
};